import { render, staticRenderFns } from "./ZBpartner.vue?vue&type=template&id=22563f0a&scoped=true&"
import script from "./ZBpartner.vue?vue&type=script&lang=js&"
export * from "./ZBpartner.vue?vue&type=script&lang=js&"
import style0 from "./ZBpartner.vue?vue&type=style&index=0&id=22563f0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22563f0a",
  null
  
)

export default component.exports